import DotForm from './DotForm/DotForm';
import RegistrationLayout from '#app/layouts/RegistrationLayout';

interface Props {}

function CreateAccount(props: Props) {
  return (
    <RegistrationLayout>
      <DotForm />
    </RegistrationLayout>
  );
}

export default CreateAccount;
